export enum ESanityDocument {
  BACKUP = 'backup',
  HEADER = 'header',
  AB_TEST = 'abTest',
  TRANSLATION_METADATA = 'translation.metadata',
  SHOP_SUBCATEGORY_CAROUSEL = 'subcategoryCarousel',
  BANNER_WEB_CAROUSEL = 'bannerWebCarousel',
  MIGRATION = 'migration',
}
